module.exports = __webpack_public_path__ + "b98d4cc679827b8effebbb1eac4545c4.svg";